import { useState, useEffect } from 'react';

import { FeaturesTabSection } from './components/FeaturesTabSection';

const navigation = [
  { 
    name: 'Products', 
    href: '#',
    dropdown: [
      { name: 'Sample Management', href: '#' },
      { name: 'Version Control', href: '#' },
      { name: 'Reports', href: '#' },
      { name: 'AI LIMS', href: '#' },
      { name: 'Integrations', href: '#' },
    ]
  },
  { 
    name: 'Industries', 
    href: '#',
    dropdown: [
      { name: 'Biopharma', href: '#' },
      { name: 'Clinical Research', href: '#' },
      { name: 'Academia', href: '#' },
      { name: 'Biotech', href: '#' },
      { name: 'Manufacturing', href: '#' },
    ]
  },
  { 
    name: 'Resources', 
    href: '#',
    dropdown: [
      { name: 'Blog', href: '#' },
      { name: 'Case Studies', href: '#' },
      { name: 'Documentation', href: '#' },
      { name: 'Support', href: '#' },
    ]
  },
  { name: 'Pricing', href: '#' },
  { name: 'Contact Us', href: '#' },
];

export default function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [mobileMenuOpen]);

  return (
    <div className="bg-white relative overflow-hidden">
      {/* Navbar */}
      <header className="fixed inset-x-0 top-0 z-50 bg-white/80 backdrop-blur-md border-gray-100">
        <nav className="flex items-center justify-between p-6 lg:px-12 max-w-[1400px] mx-auto" aria-label="Global">
          <div className="flex lg:flex-1">
            <a href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">Limsbase</span>
              <img
                alt="Limsbase"
                src="./limsbase_logo.png"
                className="h-8 w-auto"
              />
            </a>
          </div>
          <div className="flex lg:hidden">
            <button
              onClick={() => setMobileMenuOpen(true)}
              className="-m-2.5 inline-flex items-center justify-center rounded-full p-2.5 text-gray-700"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-12">
            {[].map((item) => (
              <div key={item.name} className="relative group">
                {item.dropdown ? (
                  <>
                    <button
                      className="text-sm font-semibold text-gray-900 flex items-center gap-1 hover:text-gray-600"
                      onMouseEnter={() => setOpenDropdown(item.name)}
                    >
                      {item.name}
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {openDropdown === item.name && (
                      <div
                        className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg ring-1 ring-gray-200 py-2 z-50"
                        onMouseEnter={() => setOpenDropdown(item.name)}
                        onMouseLeave={() => setOpenDropdown(null)}
                      >
                        {item.dropdown.map((subItem) => (
                          <a
                            key={subItem.name}
                            href={subItem.href}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                          >
                            {subItem.name}
                          </a>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <a href={item.href} className="text-sm font-semibold text-gray-900 hover:text-gray-600">
                    {item.name}
                  </a>
                )}
              </div>
            ))}
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end space-x-4">
            {/* <button className="text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 px-4 py-2 rounded-full">
              Log in
            </button> */}
            <a
              href="https://calendly.com/mattlong53/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-semibold text-white px-4 py-2 rounded-full border border-gray-300"
              style={{ backgroundColor: '#5384EB' }}
            >
              Request a Demo
            </a>
          </div>
        </nav>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <>
            <div className="fixed inset-0 bg-black/50 z-[60]" onClick={() => setMobileMenuOpen(false)} />
            <div className="fixed inset-0 bg-white z-[70] overflow-hidden">
              <div className="h-full flex flex-col">
                {/* Mobile Menu Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                  <img
                    src="./limsbase_logo.png"
                    alt="Limsbase"
                    className="h-8 w-auto"
                  />
                  <button onClick={() => setMobileMenuOpen(false)} className="p-2 text-gray-700 hover:bg-gray-100 rounded-full -mr-2">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                
                {/* Mobile Menu Content */}
                <div className="flex-1 overflow-y-auto">
                  <nav className="p-6 flex flex-col gap-2">
                    {[].map((item) => (
                      <div key={item.name}>
                        {item.dropdown ? (
                          <div>
                            <button
                              className="w-full px-4 py-4 text-lg font-semibold text-gray-900 hover:bg-gray-50 rounded-lg flex items-center justify-between"
                              onClick={() => setOpenDropdown(openDropdown === item.name ? null : item.name)}
                            >
                              {item.name}
                              <svg 
                                className={`w-5 h-5 transition-transform ${openDropdown === item.name ? 'rotate-180' : ''}`}
                                fill="none" 
                                viewBox="0 0 24 24" 
                                stroke="currentColor"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                              </svg>
                            </button>
                            {openDropdown === item.name && (
                              <div className="ml-4 mt-2 space-y-2">
                                {item.dropdown.map((subItem) => (
                                  <a
                                    key={subItem.name}
                                    href={subItem.href}
                                    className="block px-4 py-2 text-base text-gray-600 hover:bg-gray-50 rounded-lg"
                                    onClick={() => setMobileMenuOpen(false)}
                                  >
                                    {subItem.name}
                                  </a>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : (
                          <a
                            href={item.href}
                            className="block px-4 py-4 text-lg font-semibold text-gray-900 hover:bg-gray-50 rounded-lg"
                            onClick={() => setMobileMenuOpen(false)}
                          >
                            {item.name}
                          </a>
                        )}
                      </div>
                    ))}
                  </nav>
                </div>
                
                {/* Mobile Menu Footer */}
                <div className="p-6 border-t border-gray-200 bg-white">
                  <div className="flex flex-col gap-3">
                    {/* <button className="w-full text-base font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 px-6 py-3 rounded-lg">
                      Log in
                    </button> */}
                    <a
                      href="https://calendly.com/mattlong53/30min"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full text-center text-base font-semibold text-white px-6 py-3 rounded-lg block"
                      style={{ backgroundColor: '#5384EB' }}
                    >
                      Request a Demo
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </header>

      {/* Background Design Elements */}
      {/* <div
        aria-hidden="true"
        className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
      >
        <div
          className="relative left-[calc(50%-11rem)] sm:left-[calc(50%-30rem)] aspect-[1155/678] w-[72.1875rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#5384EB] to-[#B5CFFF] opacity-30"
          style={{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
          }}
        />
      </div>
      
      <div
        aria-hidden="true"
        className="absolute top-0 right-0 -z-10 transform-gpu overflow-hidden blur-3xl"
      >
        <div
          className="relative aspect-square w-[40rem] bg-gradient-to-bl from-[#5384EB] via-[#7BA3F0] to-[#B5CFFF] opacity-20 rounded-full"
          style={{
            transform: 'translate(30%, -20%)',
          }}
        />
      </div>

      <div 
        className="absolute inset-0 -z-10 h-full w-full bg-white"
        style={{
          backgroundImage: `linear-gradient(to right, #5384eb08 1px, transparent 1px),
                           linear-gradient(to bottom, #5384eb08 1px, transparent 1px)`,
          backgroundSize: '64px 64px',
        }}
      /> */}

      {/* Hero Section */}
      <main className="relative isolate px-6 pt-36 sm:pt-44 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
        {/* Beta Badge */}
        {/* <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-medium mb-6">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
          </span>
          Launching Beta - Limited spots available
        </div> */}

        <h1 className="text-4xl sm:text-6xl font-bold text-gray-900 tracking-tight">
          Modern LIMS for Smarter, Faster Lab Operations
        </h1>
        
        <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto">
          Pre-built templates for testing labs—minerals, environmental, cannabis. 
          Customize to your workflow in days, not months.
        </p>
        
        {/* CTA Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
          
            <a href="./_rm.mp4"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-white text-sm font-semibold shadow-sm hover:opacity-90"
            style={{ backgroundColor: '#5384EB' }}
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
            Watch Demo (5 min)
          </a>
          
          
            <a href="https://calendly.com/mattlong53/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center rounded-full px-6 py-3 bg-white text-sm font-semibold shadow-sm hover:bg-gray-50 border-2 border-gray-300"
          >
            Request Live Demo
          </a>
        </div>
        
        {/* Social Proof / Beta Info */}
        <p className="mt-6 text-sm text-gray-500">
          🎉 Founding customers get 3 months free + 25% off first year
        </p>
      </div>

        {/* Dashboard Preview */}
        {/* <div className="mx-auto mt-16 max-w-[1400px] px-8">
          <div className="bg-white rounded-3xl shadow-2xl p-8 ring-1 ring-gray-200">
            <div className="space-y-6">
              <div className="flex items-center justify-between pb-4 border-b">
                <h3 className="text-lg font-semibold text-gray-900">Laboratory Dashboard</h3>
                <div className="flex gap-2">
                  <button className="px-4 py-2 text-sm font-medium text-white rounded-lg" style={{ backgroundColor: '#5384EB' }}>
                    New Sample
                  </button>
                  <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg">
                    Reports
                  </button>
                </div>
              </div>
              
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { label: 'Active Samples', value: '1,234', color: '#5384EB' },
                  { label: 'Completed Tests', value: '5,678', color: '#10B981' },
                  { label: 'Pending Review', value: '89', color: '#F59E0B' },
                  { label: 'Reports Generated', value: '432', color: '#8B5CF6' },
                ].map((stat) => (
                  <div key={stat.label} className="p-4 bg-gray-50 rounded-xl">
                    <div className="text-2xl font-bold" style={{ color: stat.color }}>{stat.value}</div>
                    <div className="text-sm text-gray-600 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
              
              <div className="overflow-hidden">
                <table className="w-full text-left text-sm">
                  <thead className="border-b">
                    <tr>
                      <th className="py-3 px-4 font-semibold text-gray-700">Sample ID</th>
                      <th className="py-3 px-4 font-semibold text-gray-700">Status</th>
                      <th className="py-3 px-4 font-semibold text-gray-700">Priority</th>
                      <th className="py-3 px-4 font-semibold text-gray-700">Assigned</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { id: 'S-001234', status: 'In Progress', priority: 'High', assigned: 'Dr. Smith' },
                      { id: 'S-001235', status: 'Pending', priority: 'Medium', assigned: 'Dr. Johnson' },
                      { id: 'S-001236', status: 'Complete', priority: 'Low', assigned: 'Dr. Williams' },
                    ].map((row) => (
                      <tr key={row.id} className="border-b border-gray-100">
                        <td className="py-3 px-4 text-gray-900">{row.id}</td>
                        <td className="py-3 px-4">
                          <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                            row.status === 'Complete' ? 'bg-green-100 text-green-700' :
                            row.status === 'In Progress' ? 'bg-blue-100 text-blue-700' :
                            'bg-yellow-100 text-yellow-700'
                          }`}>
                            {row.status}
                          </span>
                        </td>
                        <td className="py-3 px-4 text-gray-600">{row.priority}</td>
                        <td className="py-3 px-4 text-gray-600">{row.assigned}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}

      <div className="mx-auto mt-16 mb-16 max-w-[1400px] px-8">
          <div className="rounded-xl overflow-hidden border border-gray-200 shadow-lg">
            <img
              src="/app_preview_2.png"
              alt="Limsbase Dashboard Preview"
              className="w-full h-auto object-cover"
            />
          </div>
      </div>

      {/* Partner/Client Section */}
      <section className="py-16 bg-gray-50">
        <div className="mx-auto max-w-[1400px] px-8 lg:px-12">
          <p className="text-center text-sm font-semibold text-gray-600 mb-8">Trusted by leading organizations</p>
          <div className="flex flex-wrap justify-center items-center gap-12">
            <img 
              src="https://safplusconsortium.com/wp-content/uploads/2024/08/nrcan-logo-cutout.png" 
              alt="NRCan" 
              className="h-16 w-auto object-contain grayscale hover:grayscale-0 transition-all"
            />
          </div>
        </div>
      </section>

      <FeaturesTabSection/>

      {/* Feature Section 1 - Sample Tracking */}
      <section className="py-20 bg-white">
        <div className="mx-auto max-w-[1400px] px-8 lg:px-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Screenshot */}
            <div className="order-2 md:order-1">
              <img 
                src="/sample_page.png" 
                alt="Sample Tracking"
                className="rounded-2xl shadow-2xl ring-1 ring-gray-200"
              />
            </div>
            
            {/* Text */}
            <div className="order-1 md:order-2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Track Every Sample from Submit to Report
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Complete chain of custody. Barcode labels. Status updates. 
                Your team always knows where samples are.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <div>
                    <strong className="text-gray-900">Barcode scanning</strong>
                    <p className="text-gray-600">Print labels, scan to update status</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <div>
                    <strong className="text-gray-900">Chain of custody</strong>
                    <p className="text-gray-600">Audit trail for every sample</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <div>
                    <strong className="text-gray-900">Real-time updates</strong>
                    <p className="text-gray-600">Clients see status in portal</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Feature Section 2 - CSV Upload */}
      <section className="py-20 bg-gray-50">
        <div className="mx-auto max-w-[1400px] px-8 lg:px-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Text */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Import Your Data in Seconds
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Upload CSV files from your instruments. Map columns to your fields. 
                Build QC rules to validate automatically.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <div>
                    <strong className="text-gray-900">CSV import</strong>
                    <p className="text-gray-600">Upload data from any instrument</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <div>
                    <strong className="text-gray-900">Column mapping</strong>
                    <p className="text-gray-600">Map once, reuse for every import</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <div>
                    <strong className="text-gray-900">Automated QC checks</strong>
                    <p className="text-gray-600">Flag values outside your thresholds</p>
                  </div>
                </li>
              </ul>
            </div>
            
            {/* Screenshot */}
            <div>
              <img 
                src="/sample_upload.png" 
                alt="CSV Upload"
                className="rounded-2xl shadow-2xl ring-1 ring-gray-200"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Feature Section 3 - COA Generation */}
      <section className="py-20 bg-white">
        <div className="mx-auto max-w-[1400px] px-8 lg:px-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Screenshot */}
            {/* <div className="order-2 md:order-1">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 shadow-xl ring-1 ring-gray-200">
                <div className="bg-white rounded-lg shadow-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-blue-600 rounded-full"></div>
                    <div>
                      <div className="h-3 w-32 bg-gray-300 rounded"></div>
                      <div className="h-2 w-24 bg-gray-200 rounded mt-2"></div>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="h-12 bg-gray-100 rounded"></div>
                    <div className="h-12 bg-gray-100 rounded"></div>
                    <div className="h-12 bg-blue-50 rounded border-2 border-blue-500"></div>
                  </div>
                </div>
              </div>
            </div> */}

            <div>
              <img 
                src="/user_requests.png" 
                alt="CSV Upload"
                className="rounded-2xl shadow-2xl ring-1 ring-gray-200"
              />
            </div>

            {/* Text */}
            <div className="order-1 md:order-2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Give Clients 24/7 Access to Their Results
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Your clients get a branded portal to track samples, 
                view results, and download reports anytime.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <div>
                    <strong className="text-gray-900">Real-time status updates</strong>
                    <p className="text-gray-600">Clients see exactly where their samples are</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <div>
                    <strong className="text-gray-900">Instant notifications</strong>
                    <p className="text-gray-600">Automatic emails when results are ready</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <div>
                    <strong className="text-gray-900">Your branding</strong>
                    <p className="text-gray-600">White-labeled portal with your logo</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="mx-auto max-w-[1400px] px-8 lg:px-12">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-16">
            Built for Labs
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {[
              { 
                name: 'Minerals', 
                color: 'text-gray-600',
                icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                      <path d="M6 5h12l3 5l-8.5 9.5a.7.7 0 0 1-1 0L3 10z"/>
                      <path d="M10 12L8 9.8l.6-1"/>
                    </g>
                  </svg>
                )
              },
              { 
                name: 'Cannabis', 
                color: 'text-green-600',
                icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66l.95-2.3c.48.17.98.3 1.34.3C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75C7 8 17 8 17 8"/>
                  </svg>
                )
              },
              { 
                name: 'Environmental', 
                color: 'text-cyan-600',
                icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M2 22v-2s5-2 10-2s10 2 10 2v2zm9.3-12.9c-1.2-3.9-7.3-3-7.3-3s.2 7.8 5.9 6.6C9.5 9.8 8 9 8 9c2.8 0 3 3.4 3 3.4V17h2v-4.2s0-3.9 3-4.9c0 0-2 3-2 5c7 .7 7-8.9 7-8.9s-8.9-1-9.7 5.1"/>
                  </svg>
                )
              },
              { 
                name: 'Food & Bev', 
                color: 'text-orange-600',
                icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                      <path d="M4 11.319c0 3.102.444 5.319 2.222 7.978c1.351 1.797 3.156 2.247 5.08.988c.426-.268.97-.268 1.397 0c1.923 1.26 3.728.809 5.079-.988C19.556 16.637 20 14.421 20 11.32C20 8.659 18.01 6 15.556 6c-1.267 0-2.41.693-3.22 1.44a.5.5 0 0 1-.672 0C10.855 6.694 9.711 6 8.444 6C5.99 6 4 8.66 4 11.319"/>
                      <path d="M7 12c0-1.47.454-2.34 1.5-3M12 7c0-1.2.867-4 3-4"/>
                    </g>
                  </svg>
                )
              },
              { 
                name: 'Clinical', 
                color: 'text-red-600',
                icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" viewBox="0 0 48 48">
                    <g fill="currentColor">
                      <path d="M11 30a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1m1 4a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2zm2-13v-3h2v3h3v2h-3v3h-2v-3h-3v-2z" />
                      <path fillRule="evenodd" d="M15 6a3 3 0 0 0-3 3H9a3 3 0 0 0-3 3v27a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3V12a3 3 0 0 0-3-3h-3a3 3 0 0 0-3-3zm8 6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1zm-11-1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h3a1 1 0 0 1 1 1v27a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V12a1 1 0 0 1 1-1zm24 6a3 3 0 1 1 6 0v20.303l-3 4.5l-3-4.5zm3-1a1 1 0 0 0-1 1v2h2v-2a1 1 0 0 0-1-1m0 22.197l1-1.5V21h-2v15.697z" clipRule="evenodd" />
                    </g>
                  </svg>
                )
              },
              { 
                name: 'Pharma', 
                color: 'text-purple-600',
                icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" viewBox="0 0 48 48">
                    <path fill="currentColor" fillRule="evenodd" d="M42.79 13.002c-1.626-.134-3.863-.28-6.8-.396L37.468 7.9c.56-1.78-.13-3.844-2.023-4.623a24 24 0 0 0-2.982-1a24 24 0 0 0-3.083-.619c-2.029-.268-3.66 1.174-4.068 2.994l-1.74 7.743c-9.185.01-15.056.335-18.38.608a5.08 5.08 0 0 0-4.687 5.335c.237 4.853.93 9.21 1.675 12.686c.773 3.61 2.711 6.69 5.538 8.679c-.499.645-.94 1.449-1.138 2.41c-.245 1.188.233 2.209.952 2.874c.686.635 1.608.984 2.511 1.041c2.35.15 6.822.348 13.947.348s11.597-.199 13.948-.348c.903-.057 1.827-.406 2.513-1.042c.718-.666 1.196-1.687.95-2.877a5.8 5.8 0 0 0-.96-2.167c2.679-1.777 4.554-4.576 5.312-7.919c.786-3.464 1.52-8.066 1.741-13.695a5.11 5.11 0 0 0-4.704-5.325m-18.798 2.392c-9.357 0-15.273.328-18.553.598a2.08 2.08 0 0 0-1.936 2.2a76.5 76.5 0 0 0 1.611 12.202c.757 3.53 2.826 6.268 5.694 7.656a1.5 1.5 0 0 1 .251 2.546c-.658.498-1.358 1.24-1.54 2.121l-.001.007q.008.016.053.06c.118.11.361.23.663.25c2.279.144 6.688.341 13.757.341c7.068 0 11.478-.197 13.758-.342c.302-.019.546-.14.664-.249a.3.3 0 0 0 .053-.06l-.002-.008c-.165-.8-.759-1.491-1.38-1.996a1.5 1.5 0 0 1 .341-2.538c2.703-1.188 4.677-3.622 5.403-6.823c.749-3.299 1.456-7.718 1.67-13.15a2.11 2.11 0 0 0-1.953-2.217c-3.28-.27-9.196-.598-18.553-.598m-1.516 4.087c.415-.053.919-.09 1.516-.09c.598 0 1.101.037 1.517.09c1.194.154 1.863 1.196 1.895 2.27c.025.835.053 2.04.07 3.657c1.617.018 2.823.046 3.657.07c1.075.033 2.117.701 2.27 1.896c.054.416.091.919.091 1.517s-.037 1.1-.09 1.516c-.154 1.195-1.196 1.864-2.271 1.896c-.834.025-2.04.052-3.657.07a193 193 0 0 1-.07 3.656c-.032 1.075-.7 2.117-1.895 2.271c-.416.054-.92.09-1.517.09c-.598 0-1.1-.036-1.516-.09c-1.195-.154-1.864-1.196-1.896-2.27c-.025-.834-.053-2.04-.07-3.657a194 194 0 0 1-3.657-.07c-1.075-.032-2.116-.701-2.27-1.896c-.054-.415-.09-.919-.09-1.516c0-.598.036-1.101.09-1.517c.154-1.195 1.195-1.863 2.27-1.895c.834-.025 2.04-.053 3.657-.07c.017-1.617.045-2.823.07-3.657c.032-1.075.7-2.117 1.896-2.27" clipRule="evenodd" />
                  </svg>
                )
              },
            ].map((industry, idx) => (
              <div key={idx} className="p-6 bg-white rounded-xl text-center hover:shadow-md transition-shadow border border-gray-200">
                <div className={`mb-3 flex justify-center ${industry.color}`}>
                  {industry.icon}
                </div>
                <p className="text-sm font-medium text-gray-700">{industry.name}</p>
              </div>
            ))}
          </div>
          <p className="text-center text-gray-600 mt-8">
            More industries coming soon
          </p>
        </div>
      </section>

      {/* Features Section */}
      {/* <section className="py-20 bg-white">
        <div className="mx-auto max-w-[1400px] px-8 lg:px-12">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">
            Unleash the full potential of your laboratory
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
            {[
              { title: 'Smart Inventory Tracking', desc: 'Real-time monitoring of reagents, samples, and equipment' },
              { title: 'Streamline Quality Integration', desc: 'Automated QC checks and compliance reporting' },
              { title: 'Automated Reporting and Analytics', desc: 'Generate insights with AI-powered analytics' },
              { title: 'Enhance User Interface', desc: 'Intuitive design for seamless lab operations' },
              { title: 'Real-Time Sample Management', desc: 'Track samples from collection to disposal' },
              { title: 'Manage All Day-to-Day Workflows', desc: 'Centralized platform for all lab processes' },
            ].map((feature, idx) => (
              <div key={idx} className="p-6 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 rounded-lg mb-4" style={{ backgroundColor: '#5384EB' }}></div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 text-sm">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Industries Section */}
      {/* <section className="py-20 bg-gray-50">
        <div className="mx-auto max-w-[1400px] px-8 lg:px-12">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-16">
            Serving the unique needs of every laboratory
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {[
              { name: 'Biological Samples', icon: '🧬' },
              { name: 'Laboratory Equipment and Infrastructure', icon: '⚗️' },
              { name: 'Research and Academia', icon: '🎓' },
              { name: 'Construction', icon: '🏗️' },
              { name: 'Laboratory Operations and Management', icon: '📊' },
              { name: 'Cannabis', icon: '🌿' },
              { name: 'IT and Software for Laboratory', icon: '💻' },
              { name: 'Clinical and Hospital Laboratories', icon: '🏥' },
              { name: 'Laboratory Data and Reports', icon: '📈' },
              { name: 'Calibration Standards', icon: '📋' },
            ].map((industry, idx) => (
              <div key={idx} className="p-6 bg-white rounded-xl text-center hover:shadow-md transition-shadow">
                <div className="text-4xl mb-3">{industry.icon}</div>
                <p className="text-sm font-medium text-gray-700">{industry.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Pricing Section - ADD THIS */}
      <section id="pricing"  className="py-20 bg-white">
        <div className="mx-auto max-w-5xl px-8 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Simple, Transparent Pricing
            </h2>
            <p className="text-lg text-gray-600">
              No $100K upfront. No 6-month implementations. Just $999/month.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Starter Plan */}
            <div className="border-2 border-gray-200 rounded-2xl p-8 bg-white">
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Starter</h3>
                <div className="flex items-baseline gap-2">
                  <span className="text-4xl font-bold text-gray-900">$299</span>
                  <span className="text-gray-600">/month</span>
                </div>
                <p className="text-gray-600 mt-2">Perfect for small labs getting started</p>
              </div>

              <ul className="space-y-4 mb-8">
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">Up to 5 users</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">1 lab/workspace</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">Sample tracking & QC</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">CSV upload</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">COA generation</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">Email support</span>
                </li>
              </ul>

              <button className="w-full py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-lg">
                Coming Q2 2025
              </button>
            </div>

            {/* Professional Plan */}
            <div className="border-2 rounded-2xl p-8 bg-white relative" style={{ borderColor: '#5384EB' }}>
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
                  Most Popular
                </span>
              </div>

              <div className="mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Professional</h3>
                <div className="flex items-baseline gap-2">
                  <span className="text-4xl font-bold text-gray-900">$999</span>
                  <span className="text-gray-600">/month</span>
                </div>
                <p className="text-gray-600 mt-2">For established labs</p>
              </div>

              <ul className="space-y-4 mb-8">
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">Unlimited users</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">Multiple labs/workspaces</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">Everything in Starter</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">Client portal</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">Custom workflows</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-700">Priority support</span>
                </li>
              </ul>

              
                <a href="https://calendly.com/mattlong53/30min"
                className="w-full py-3 px-4 text-white font-semibold rounded-lg block text-center hover:opacity-90"
                style={{ backgroundColor: '#5384EB' }}
                >
                Book a Demo
              </a>
            </div>
          </div>

          <div className="text-center mt-12">
            {/* <p className="text-gray-600 mb-2">
              <strong>Early Access Pricing:</strong> First 5 customers get 50% off for 6 months
            </p> */}
            <p className="text-sm text-gray-500">
              Need enterprise features? <a href="https://calendly.com/mattlong53/30min" className="text-blue-600 hover:text-blue-700 font-semibold">Let's talk custom pricing →</a>
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      {/* <section className="py-20 bg-white">
        <div className="mx-auto max-w-[1400px] px-8 lg:px-12">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-16">What Our Clients Are Saying</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[1, 2, 3].map((i) => (
              <div key={i} className="p-8 bg-gray-50 rounded-2xl">
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="text-yellow-400">★</span>
                  ))}
                </div>
                <p className="text-gray-600 mb-6">
                  "Limsbase has transformed how we manage our laboratory operations. The intuitive interface and powerful features have increased our efficiency significantly."
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gray-300 rounded-full"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Lab Director</p>
                    <p className="text-sm text-gray-500">Research Institute</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="space-y-4">
            {[
              {
                q: 'How is this different from Excel?',
                a: 'LIMSBase gives you automated QC, sample tracking, client portals, and COA generation. Excel requires manual work for everything.'
              },
              {
                q: 'How is this different from traditional LIMS?',
                a: 'Traditional LIMS require long implementations, IT teams, and expensive consultants. Limsbase starts with pre-built templates you can customize yourself—no developers or 6-month projects required.'
              },
              {
                q: 'Can I customize the pages and workflows?',
                a: 'Yes! Add custom pages, components, rename things, and configure workflows without code. Start with a template and make it yours.'
              },
              {
                q: 'Can I import data from my instruments?',
                a: 'Yes. Upload CSV files from your instruments, map columns to your fields, and import hundreds of samples at once. Set it up once, reuse for every batch.'
              },
              {
                q: 'Is my data secure?',
                a: 'Yes. Cloud-hosted on AWS with encryption, daily backups, and SOC2 compliance (in progress).'
              },
              {
                q: 'Can I export my data?',
                a: 'Yes. Export all data as CSV/Excel anytime. No vendor lock-in.'
              },
            ].map((faq, idx) => (
              <div key={idx} className="p-6 bg-white rounded-xl border border-gray-200">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold text-gray-900 mb-2">{faq.q}</p>
                    <p className="text-gray-600 text-sm">{faq.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="mx-auto max-w-3xl px-8 lg:px-12 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Join the Waitlist
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Limsbase is launching Q2 2025. Get early access pricing 
            and be first to try the platform.
          </p>
          
          <div className="bg-gray-50 rounded-2xl p-8 max-w-md mx-auto">
            <div className="space-y-4">
              <input
                type="email"
                placeholder="Your email"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="text"
                placeholder="Lab name"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                <option>Select your lab type</option>
                <option>Minerals/Geochemistry</option>
                <option>Cannabis</option>
                <option>Environmental</option>
                <option>Food & Beverage</option>
                <option>Other</option>
              </select>
              <button className="w-full py-3 px-4 text-white font-semibold rounded-lg" style={{ backgroundColor: '#5384EB' }}>
                Join Waitlist
              </button>
            </div>
            <p className="text-sm text-gray-500 mt-4">
              ✨ First 5 customers get 25% off for 12 months
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section (after feature sections) */}
      <section 
        className="py-20"
        style={{ backgroundColor: '#5384EB' }}
      >
        <div className="mx-auto max-w-3xl px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Modern LIMS for Today’s Labs
          </h2>
          <p className="text-lg text-blue-100 mb-8">
            Join labs switching to limsbase. 
            Book a demo to see how it works for your lab.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            
              <a href="https://calendly.com/mattlong53/30min"
              className="px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-blue-50 inline-block"
            >
              Book a Demo
            </a>
            
              <a href="#pricing"
              className="px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg hover:bg-blue-700 inline-block"
            >
              See Pricing
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-16 bg-white border-t border-gray-200">
        <div className="mx-auto max-w-[1400px] px-8 lg:px-12">
          {/* Footer Links Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            {/* Products */}
            {/* <div>
              <h3 className="text-gray-900 font-bold mb-4 text-sm">Products</h3>
              <ul className="space-y-3">
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Sample Management</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Version Control</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Reports</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">AI LIMS</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Integrations</a></li>
              </ul>
            </div> */}

            {/* Industries */}
            {/* <div>
              <h3 className="text-gray-900 font-bold mb-4 text-sm">Industries</h3>
              <ul className="space-y-3">
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Biopharma</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Clinical Research</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Academia</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Biotech</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Manufacturing</a></li>
              </ul>
            </div> */}

            {/* Resources */}
            {/* <div>
              <h3 className="text-gray-900 font-bold mb-4 text-sm">Resources</h3>
              <ul className="space-y-3">
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Blog</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Case Studies</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Documentation</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Support</a></li>
              </ul>
            </div> */}

            {/* Company */}
            {/* <div>
              <h3 className="text-gray-900 font-bold mb-4 text-sm">Company</h3>
              <ul className="space-y-3">
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">About Us</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Contact Us</a></li>
                <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900">Careers</a></li>
              </ul>
            </div> */}
          </div>

          {/* Bottom Section */}
          <div className="pt-8 border-t border-gray-200">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6">
              {/* Logo and Social */}
              <div className="flex flex-col items-center md:items-start gap-4">
                <img src="./limsbase_logo.png" alt="Limsbase" className="h-8" />
                {/* <div className="flex gap-4">
                  <a href="#" className="text-gray-400 hover:text-gray-600">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                  <a href="#" className="text-gray-400 hover:text-gray-600">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                  <a href="#" className="text-gray-400 hover:text-gray-600">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                  </a>
                </div> */}
              </div>

              {/* Copyright and Links */}
              <div className="flex flex-col md:flex-row items-center gap-4 text-sm text-gray-500">
                <span>Copyright © 2026 Limsbase, Inc</span>
                {/* <span className="hidden md:inline">|</span>
                <a href="#" className="hover:text-gray-700">Privacy Policy</a>
                <span className="hidden md:inline">|</span>
                <a href="#" className="hover:text-gray-700">Terms of Service</a> */}
              </div>

              {/* Compliance Badges */}
              {/* <div className="flex gap-3">
                <div className="w-12 h-12 bg-gray-100 rounded flex items-center justify-center">
                  <span className="text-xs font-bold text-gray-600">SOC2</span>
                </div>
                <div className="w-12 h-12 bg-gray-100 rounded flex items-center justify-center">
                  <span className="text-xs font-bold text-gray-600">HIPAA</span>
                </div>
                <div className="w-12 h-12 bg-gray-100 rounded flex items-center justify-center">
                  <span className="text-xs font-bold text-gray-600">GDPR</span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </footer>
      </main>
    </div>
  );
}
